var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapInstallation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 84",
    width: 62,
    height: 84,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map_pluvio-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { opacity: 6565651;fill: #ffffff } \n\t\t.s1 { fill: #9f0505 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse-1",
    className: "s0",
    d: "m30.9 57.2c-12.9 0-23.4-10.8-23.4-24.1 0-13.4 10.5-24.2 23.4-24.2 12.9 0 23.4 10.8 23.4 24.2 0 13.3-10.5 24.1-23.4 24.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m19 22.2c0 0.8 2 1.5 4.4 1.8l4.3 0.4 0.4 9 0.4 9.1h-4.8c-2.5 0-4.7 0.5-4.7 1.3 0 0.9 5 1.4 12.1 1.4 7.1 0 12.1-0.5 12.1-1.4 0-0.8-1.8-1.3-4-1.3h-4.1v-9.4-9.4h4.1c2.2 0 4-0.7 4-1.4 0-0.8-5-1.3-12.1-1.3-6.7 0-12.1 0.5-12.1 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    fillRule: "evenodd",
    className: "s1",
    d: "m29.2 76.7c-0.4-0.2-1.4-1.4-2.1-2.6-1.9-3.1-4-5.6-10.1-12-6.1-6.6-8.5-9.7-10.6-14.2-2.4-4.9-3-7.8-3-14.1 0-6 0.5-8.2 2.6-12.9 3.6-7.5 10-12.8 18-15 3.3-0.9 9.5-1 12.7-0.2 14.2 3.4 23.2 16.7 21.5 31.9-1 8.8-4.2 14.6-13.8 24.7-5.1 5.2-8.3 9.1-9.9 11.9-1.7 2.8-3.3 3.6-5.3 2.5zm6.9-24.1c7-1.8 12.7-7.5 14.6-14.7 0.8-2.7 0.8-7.7 0-10.4-1.9-7.2-7.7-12.9-15.1-14.7-2.8-0.8-8.6-0.5-11.3 0.4-6.2 2.1-11 6.9-13.2 13.3-1 2.7-1.2 7.9-0.5 10.9 2 8.1 8.8 14.4 17.1 15.7 2.1 0.4 5.9 0.2 8.4-0.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapInstallation);
export default __webpack_public_path__ + "static/media/map_installation.8357eb1bd06cc4512723ddebca4129aa.svg";
export { ForwardRef as ReactComponent };